import React, { useEffect } from "react";
import Input from "../../../components/form/Input";
import useForm from "../../../hooks/useForm";
import Button from "../../../components/form/Button";
import useMutation from "../../../hooks/useMutation";
import Editor from "../../../components/form/Editor";
import { collectionTemplateAddEdit } from "../../../services/collectionService";

const validation = {
  name: { required: true, message: "Name is required" },
  content: { required: true, message: "Collection content is required" },
};

const ManageCollectionTemplate = ({
  getResponse = () => {},
  close = () => {},
  data,
}) => {
  useEffect(() => {
    if (data?._id) {
      setFieldsValue(data);
    }
  }, [data]);

  const {
    values,
    handleChange,
    handleSubmit,
    errors,
    setFieldsValue,
    resetField,
    formValidate,
  } = useForm({
    validationRules: validation,
    initialState: {
      name: "",
      content: "",
    },
  });

  const {
    mutate,
    error,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await collectionTemplateAddEdit({
        ...val,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <div className="grid grid-cols-12 gap-x-4 gap-y-4">
        <div className="relative col-span-12">
          <Input
            label="
            Name"
            inputPlaceholder={"Enter Collection Name"}
            inputName="name"
            value={values?.name}
            onChange={handleChange}
            {...formValidate(errors, "name")}
          />
        </div>
        {/* <div className="relative col-span-6">
          <Input
            label="Sender Name"
            inputPlaceholder={"Enter Sender Name"}
            inputName="fromName"
            value={values?.fromName}
            onChange={handleChange}
            {...formValidate(errors, "fromName")}
          />
        </div> */}
        <div className="relative col-span-12">
          <Editor
            label="Collection Body"
            value={values?.content}
            onChange={(val) =>
              handleChange({
                target: { name: "content", value: val },
              })
            }
            {...formValidate(errors, "content")}
          />
        </div>
      </div>
      <div className="relative col-span-4 mt-5">
        <div className="flex items-center justify-center gap-4">
          <Button
            buttonType="submit"
            buttonLabel={"Save"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            {...(isLoading && {
              loading: true,
              buttonIconPosition: "left",
              isDisable: true,
            })}
          />
          <Button
            buttonLabel={"Cancel"}
            buttonClasses={
              "!rounded-full !px-8 !h-12 !border !border-chestnut-rose !bg-transparent !text-chestnut-rose hover:!bg-chestnut-rose hover:!text-white"
            }
            buttonLabelClasses={"mx-auto"}
            buttonFunction={close}
          />
        </div>
      </div>
    </form>
  );
};

export default ManageCollectionTemplate;
